window.addEventListener("DOMContentLoaded", function () {
  const formProduct = document.querySelector(".product__meta");
  if (formProduct) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const payBlock = document.querySelector(".dynamic_button_wb_form");
        if (payBlock) {
          if (mutation.type === "childList" || mutation.type === "attributes") {
            const paymentButtons = document.querySelectorAll(
              ".shopify-payment-button .shopify-payment-button__button.shopify-payment-button__button--branded",
            );
            paymentButtons.forEach((button) => {
              if (button.children.length < 1) {
                button.style.height = "0px";
                button.style.minHeight = "0px";
              } else {
                button.style.height = "56px";
                button.style.maxHeight = "56px";
              }
            });
          }
        }
      });
    });

    observer.observe(formProduct, {
      childList: true,
      attributes: true,
      subtree: true,
    });
  }
});
